<div fxLayout="column" fxLayoutAlign="start center" fxFlexFill>

  <!-- <app-languages class="abs-centered"></app-languages> -->

  <div fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="10px" class="form-auth">

    <div fxLayoutAlign="center center" class="text-center layout-padd">
      <span class="text-lg fontPoppins">{{"forgotPass.resetPass" | translate}} </span>
    </div>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'request'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>email</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-1" [innerHTML]="'forgpass.message.request' | translate:{'email': currEmail}"></span>
      </div>
    </mat-card>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'forgMail'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>person</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-1" [innerHTML]="'main.err.noaccount' | translate:{'email': currEmail}"></span>
      </div>
    </mat-card>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="great" *ngIf="error$ === 'sended'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>email</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-1"
          [innerHTML]="'forgpass.message.resetmailpass' | translate:{'email': currEmail}"></span>
      </div>
    </mat-card>

    <form fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="stretch" class="form-auth" [formGroup]="forgotPassForm"
      #formDirective="ngForm" (ngSubmit)="submitResetPass(formDirective)">

      <div class="form-field-endorder">

        <mat-form-field appearance="outline" fxFlex class="text-sm">

          <mat-label>{{"main.word.email" | translate}}</mat-label>

          <input type="email" matInput placeholder="{{'main.word.email' | translate}}" formControlName="email" autocomplete="username" class="text-gray-700">

          <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('email')">
            <span class="mat-caption">{{"main.err.reqemail" | translate}}</span>
          </mat-error>
          <mat-error fxLayout fxLayoutAlign="start center" *ngIf="forgotPassForm.controls['email'].errors?.email">
            <span class="mat-caption">{{"main.err.emailformat" | translate}}</span>
          </mat-error>

        </mat-form-field>
      </div>

      <button [ngClass]="cssService.defaultActionButton" type="submit" angulartics2On="click" angularticsAction="submitLoginForm"
        angularticsCategory="forgotPassword">{{"forgpass.other.sendlink"
        | translate}}</button>

    </form>

  </div>

  <app-popup-loader [flagLoading]="loaderForgotPass" [size]="30"></app-popup-loader>

</div>
